/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import fam from "../../assets/paquetes/fam.jpg";
import friends from "../../assets/paquetes/friends.jpg";
import love from "../../assets/paquetes/love.jpg";

import "../../styles/PaquetesPage.css";
import paquetesTitle from "../../assets/titulos/paquetes.png";
import packages from "../../assets/titles/packages.png";

import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

interface Paquete {
  nombre: string;
  descripcion: string;
  imagen: string;
  icono: string;
}

const PaquetesPage: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [fadeKey, setFadeKey] = useState<number>(0);
  const tabpsRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const paquetes: Paquete[] = [
    {
      nombre: t("paquetes.familiar.nombre"),
      descripcion: t("paquetes.familiar.descripcion"),
      imagen: fam,
      icono: "",
    },
    {
      nombre: t("paquetes.parejas.nombre"),
      descripcion: t("paquetes.parejas.descripcion"),
      imagen: love,
      icono: "",
    },
    {
      nombre: t("paquetes.amigos.nombre"),
      descripcion: t("paquetes.amigos.descripcion"),
      imagen: friends,
      icono: "",
    },
  ];
  const handletabpChange = (index: number) => {
    setActiveIndex(index);
    setFadeKey((prev) => prev + 1);
  };

  useEffect(() => {
    const activetabp = tabpsRef.current?.querySelector(
      ".tabp-item.active"
    ) as HTMLElement;
  }, [activeIndex]);

  const formatDescripcion = (text: string) =>
    text.split(". ").map((frase, idx, arr) =>
      idx < arr.length - 1 ? (
        <span key={idx}>
          {frase}.
          <br />
        </span>
      ) : (
        <span key={idx}>{frase}</span>
      )
    );

  return (
    <div className="paquetes-page fade-tab">
      <div className="menu-icon-diva">
        <img src={menuIcon} />
      </div>
      <div className="paquetes-title-wrapper">
        <LocalizedTitleImage
          imageEn={packages}
          imageEs={paquetesTitle}
          className="paquetes-title-img"
        />
      </div>

      {/* Selector visible solo en móvil */}
      <select
        className="paquetes-select-movil"
        value={paquetes[activeIndex].nombre}
        onChange={(e) =>
          handletabpChange(
            paquetes.findIndex((p) => p.nombre === e.target.value)
          )
        }
      >
        {paquetes.map((paq, index) => (
          <option key={index} value={paq.nombre}>
            {paq.nombre}
          </option>
        ))}
      </select>

      <div className="paquetes-layout">
        {/* Sidebar IZQUIERDA */}
        <div className="paquetes-sidebar" ref={tabpsRef}>
          {paquetes.map((paq, index) => (
            <div
              key={index}
              className={`tabp-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => handletabpChange(index)}
            >
              {paq.nombre}
            </div>
          ))}
        </div>

        {/* Contenido DERECHA */}
        <div key={fadeKey} className="paquetes-contenido ">
          <div className="paquetes-info-fila">
            <div className="paquetes-img-box">
              <img
                src={paquetes[activeIndex].imagen}
                alt={paquetes[activeIndex].nombre}
                className="paquetes-img"
              />
            </div>
            <div className="paquetes-texto-box">
              <p className="paquetes-texto">
                {formatDescripcion(paquetes[activeIndex].descripcion)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaquetesPage;
